export function isProduct(item) {
    return item.section === 'Products';
}
export function isSearchSuggestion(item) {
    return item.section === 'Search Suggestions';
}
export function isInGroupSuggestion(item) {
    return item.groupName !== undefined;
}
export function isCustomSection(config) {
    return config.type === 'custom';
}
export function isAutocompleteSection(config) {
    return config.type === 'autocomplete' || !config.type;
}
export function isRecommendationsSection(config) {
    return config.type === 'recommendations';
}
